import { render, staticRenderFns } from "./ShippingCredentials.vue?vue&type=template&id=6564b7dc&scoped=true"
import script from "./ShippingCredentials.vue?vue&type=script&lang=js"
export * from "./ShippingCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6564b7dc",
  null
  
)

export default component.exports